import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { QRCodeSVG } from 'qrcode.react';
import axios from 'axios';
import { exportStockFinancials } from "./exportStockFinancials";

const StockFinancials = () => {
  const [lookupStats, setLookupStats] = useState({
  total: 0,
  updated: 0
});
const [zeroSortConfig, setZeroSortConfig] = useState({
  key: null,
  direction: "ascending"
});
const [lookupLoading, setLookupLoading] = useState(false);
const [recentlyUpdatedGtins, setRecentlyUpdatedGtins] = useState([]);
  const [editItem, setEditItem] = useState(null);
const [editValue, setEditValue] = useState("");
  const [zeroValuePopup, setZeroValuePopup] = useState(null);
const [zeroValueEdits, setZeroValueEdits] = useState({});
  const [zeroPriceOnly, setZeroPriceOnly] = useState(false);
  const [loading, setLoading] = useState(false);
  const [viewOption, setViewOption] = useState("Summary");
  const [searchQuery, setSearchQuery] = useState("");
  const [inventoryData, setInventoryData] = useState([]);
  const [selectedPharmacy, setSelectedPharmacy] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('On shelf');
  const [priceThreshold, setPriceThreshold] = useState(0);
  const [expiringWithin, setExpiringWithin] = useState("");
  const [onShelfMoreThan, setOnShelfMoreThan] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [popupData, setPopupData] = useState(null);
const [selectedLocation, setSelectedLocation] = useState('');
const [splitPackOnly, setSplitPackOnly] = useState(false);
const [logPopupData, setLogPopupData] = useState(null);
const [statusPopupData, setStatusPopupData] = useState(null);
    const [statusPopupTitle, setStatusPopupTitle] = useState("");
    const [popupSearchQuery, setPopupSearchQuery] = useState("");
const members = JSON.parse(localStorage.getItem("members") || "[]");
const memberNames = members.map(m => m.pharmacyName);
const inventoryNames = inventoryData.map(item => item.pharmacyName);
const shelfChecks = JSON.parse(localStorage.getItem("shelf_checks") || "[]");

const matched = members.find(m => m.pharmacyName === selectedPharmacy);
const pharmacyId = matched ? matched.pharmacyId : "";
let filteredShelves = shelfChecks;

if (selectedPharmacy) {
  filteredShelves = shelfChecks.filter(shelf => shelf.pharmacyId === pharmacyId);
}
const uniqueLocations = [...new Set(filteredShelves.map(shelf => shelf.description))].sort();




// Combine and deduplicate
const combinedPharmacyNames = [...new Set([...memberNames, ...inventoryNames])].sort();


useEffect(() => {
  fetchInventoryData();
}, []);

const fetchInventoryData = async () => {
  const groupId = localStorage.getItem("userId");
  if (!groupId) return;

  setLoading(true); // ✅ added

  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(`https://api.pharmacegroup.co.uk/ggetInventory?groupId=${groupId}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    let data = await response.json();
    data = data.filter(item => !item.pharmacyName?.startsWith("Warehouse"));
    setInventoryData(data);
  } catch (error) {
    console.error("Error fetching inventory data:", error);
  } finally {
    setLoading(false); // ✅ added
  }
};


const handleZeroSort = (key) => {
  let direction = "ascending";

  if (zeroSortConfig.key === key && zeroSortConfig.direction === "ascending") {
    direction = "descending";
  }

  setZeroSortConfig({ key, direction });
};

const getZeroSortIndicator = (key) => {
  if (zeroSortConfig.key !== key) return "";
  return zeroSortConfig.direction === "ascending" ? " ↑" : " ↓";
};

const handlePopupExport = () => {
  if (!sortedPopupData || sortedPopupData.length === 0) return;

  const worksheetData = [
    [`${statusPopupTitle} Drugs`],
    [`Generated on: ${new Date().toLocaleString()}`],
    [],
    ['Pharmacy', 'Drug', 'Packets', 'Qty', 'Price (£)', 'Location', 'Serial', 'Batch', 'Expiry', 'First Scanned'],
  ];

  sortedPopupData.forEach(item => {
    worksheetData.push([
      item.pharmacyName,
      item.drugName || item.vmppNm,
      parseInt(item.balance || 0),
      item.qtval,
      item.price ? (item.price / 100).toFixed(2) : "",
      item.location,
      item.serialNumber,
      item.batchNumber,
      item.expiryDate ? new Date(item.expiryDate).toLocaleDateString("en-GB") : "",
      item.firstScanned ? new Date(item.firstScanned).toLocaleDateString("en-GB") : "",
    ]);
  });

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Popup Export');
  XLSX.writeFile(workbook, `${statusPopupTitle}_Drugs_${new Date().toISOString().slice(0, 10)}.xlsx`);
};


  const resetFilters = () => {
    setViewOption("Summary");
    setSearchQuery("");

setSelectedLocation("");
    setSelectedPharmacy("");
    setSelectedStatus("On shelf");
    setExpiringWithin("");
    setOnShelfMoreThan("");
    setSplitPackOnly("");
    setPriceThreshold(0);
  };


  function getWeeksUntil(dateStr) {
  if (!dateStr) return '';
  const now = new Date();
  const target = new Date(dateStr);
  const diffMs = target - now;
  const diffWeeks = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 7));
  return diffWeeks;
}

function getWeeksSince(dateStr) {
  if (!dateStr) return '';
  const now = new Date();
  const target = new Date(dateStr);
  const diffMs = now - target;
  const diffWeeks = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 7));
  return diffWeeks;
}


const filterData = () => {
  return inventoryData.filter((item) => {
    const now = new Date();

if (expiringWithin) {
  // Parse expiry date
  const expiryDate = item.expiryDate ? new Date(item.expiryDate) : null;

  // Check for 01/01/1980 and exclude
  if (
    expiryDate &&
    expiryDate.getFullYear() === 1980 &&
    expiryDate.getMonth() === 0 && // January is month 0 in JS
    expiryDate.getDate() === 1
  ) {
    return false;
  }

  const expiryThreshold = new Date(now);
  expiryThreshold.setDate(now.getDate() + parseInt(expiringWithin) * 7);
  if (!expiryDate || expiryDate > expiryThreshold) return false;
}

    if (onShelfMoreThan) {
      const scannedDate = item.firstScanned ? new Date(item.firstScanned) : null;
      const shelfThreshold = new Date(now);
      shelfThreshold.setDate(now.getDate() - parseInt(onShelfMoreThan) * 7);
      if (!scannedDate || scannedDate > shelfThreshold) return false;
    }

    if (splitPackOnly && !item.splitpack) {
      return false;
    }

    const matchesSearch = Object.values(item).some(value =>
      value && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesPharmacy = selectedPharmacy ? item.pharmacyName === selectedPharmacy : true;
    const matchesStatus = selectedStatus ? (item.status || '').trim() === selectedStatus : true;
    //const meetsPrice = item.price >= parseInt(priceThreshold || 0);
 const matchesLocation = selectedLocation 
  ? (item.location || '').trim().toLowerCase() === selectedLocation.trim().toLowerCase()
  : true;


 const matchesZeroPrice = zeroPriceOnly
  ? (!item.price || item.price === 0)
  : true;

return matchesSearch && matchesPharmacy && matchesStatus && matchesLocation && matchesZeroPrice;
  });
};




const zeroValueItems = (() => {
  const map = {};

  inventoryData.forEach(item => {
    if (!item.price || item.price === 0) {
      const key = item.snomed || item.snomedCode || item.vmppNm;

      if (!map[key]) {
      map[key] = {
  drugName: item.drugName || item.vmppNm,
  snomed: item.snomed || item.snomedCode,
  gtin: item.gtin,
  pharmacyId: item.pharmacyId
};
      }
    }
  });

 return Object.values(map).sort((a, b) =>
  (a.drugName || "").localeCompare(b.drugName || "")
);
})();


const zeroPriceStats = (() => {
  const data = filterData();

  if (!data.length) return { allHavePrice: true };

  const hasZero = data.some(i => !i.price || i.price === 0);
  return {
    allHavePrice: !hasZero
  };
})();


    const filteredPopupData = statusPopupData ? statusPopupData.filter(item =>
    Object.values(item).some(value =>
      value && value.toString().toLowerCase().includes(popupSearchQuery.toLowerCase())
    )
  ) : [];


  const sortedPopupData = filteredPopupData.sort((a, b) => {
    const key = sortConfig.key;
    if (!key) return 0;
    const aVal = a[key] ?? '';
    const bVal = b[key] ?? '';
    if (aVal < bVal) return sortConfig.direction === 'ascending' ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === 'ascending' ? 1 : -1;
    return 0;
  });



const getSortIndicator = (key) => {
  if (sortConfig.key !== key) return '';
  return sortConfig.direction === 'ascending' ? ' ↑' : ' ↓';
};






  const groupData = (data) => {
    if (viewOption === "Pharmacy") {
      const map = {};
      data.forEach(item => {
        if (!map[item.pharmacyName]) map[item.pharmacyName] = [];
        map[item.pharmacyName].push(item);
      });
      return Object.entries(map).map(([pharmacyName, items]) => ({
        pharmacyName,
        grouped: true,
        totalPackets: items.reduce((sum, i) => sum + parseInt(i.balance || 0), 0),
        totalPrice: items.reduce((sum, i) => sum + i.price, 0),
        items,
        expiresIn: getWeeksUntil(items[0]?.expiryDate),
  onShelfFor: getWeeksSince(items[0]?.firstScanned),
      }));
    }


    
    if (viewOption === "Summary") {
      const map = {};
      data.forEach(item => {
        const key = item.pharmacyName + "|" + (item.drugName || item.vmppNm);
        if (!map[key]) map[key] = [];
        map[key].push(item);
      });
      return Object.entries(map).map(([key, items]) => {
        const [pharmacyName, drug] = key.split("|");
        return {
          pharmacyName,
          drug,
          grouped: items.length > 1,
          totalPackets: items.reduce((sum, i) => sum + parseInt(i.balance || 0), 0),
          totalPrice: items.reduce((sum, i) => sum + i.price, 0),
          items,
          expiresIn: getWeeksUntil(items[0]?.expiryDate),
  onShelfFor: getWeeksSince(items[0]?.firstScanned),
        };
      });
    }




return data.map(item => {
  const expiresIn = getWeeksUntil(item.expiryDate);
  const onShelfFor = getWeeksSince(item.firstScanned);
  return {
    ...item,
    drug: item.drugName || item.vmppNm || "",
    grouped: false,
    totalPackets: parseInt(item.balance || 0),
    totalPrice: item.price,
    expiresIn,
    onShelfFor,
    items: [item],
  };
});

  };



const handleLookupPrices = async () => {
  if (!window.confirm("Lookup prices from dmddata?")) return;

  setLookupLoading(true);

  try {
    const token = localStorage.getItem("authToken");

    const response = await fetch("https://api.pharmacegroup.co.uk/lookupPricesBulk", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: zeroValueItems
      })
    });

    if (!response.ok) {
      const text = await response.text();
      console.error("❌ Bad response:", text);
      throw new Error("Bad response from server");
    }

    const result = await response.json();
    console.log("✅ lookup result:", result);

    setLookupStats({
      total: result.total || zeroValueItems.length,
      updated: result.updated || 0
    });

    // 🔥 IMPORTANT: update UI values immediately
    if (result.prices && Array.isArray(result.prices)) {
      const updates = {};

      result.prices.forEach(p => {
        if (p.gtin && p.price) {
          updates[p.gtin] = p.price;
        }
      });

      setZeroValueEdits(prev => ({
        ...prev,
        ...updates
      }));

      // trigger highlight
      setRecentlyUpdatedGtins(result.prices.map(p => p.gtin));

      // remove highlight after 1.5s
      setTimeout(() => setRecentlyUpdatedGtins([]), 1500);
    }

  } catch (err) {
    console.error("💥 Lookup failed:", err);
    alert("Lookup failed");
  } finally {
    setLookupLoading(false);
  }
};
    const openStatusPopup = (status) => {
const data = inventoryData.filter(item => (item.status || '').trim() === status);

    setStatusPopupData(data);
    setStatusPopupTitle(status);
    setPopupSearchQuery("");
  };

  const handleSort = key => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

const displayData = groupData(filterData())
  .filter(group => {
    return group.totalPrice >= parseInt(priceThreshold || 0) * 100;
  })
  .sort((a, b) => {
    const key = sortConfig.key;
    if (!key) return 0;

    const aVal = a[key] ?? '';
    const bVal = b[key] ?? '';

    if (aVal < bVal) return sortConfig.direction === 'ascending' ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === 'ascending' ? 1 : -1;
    return 0;
  });


  const totalPackets = displayData.reduce((sum, i) => sum + (i.totalPackets || 0), 0);
  const totalPrice = displayData.reduce((sum, i) => sum + (i.totalPrice || 0), 0);

const handleExport = async () => {
  const data = filterData();

  const groupName = localStorage.getItem("organisationName");

  await exportStockFinancials({
    data,
    groupName,
    filters: {
      selectedPharmacy,
      selectedLocation,
      selectedStatus,
      searchQuery,
      priceThreshold,
      expiringWithin,
      onShelfMoreThan,
      splitPackOnly,
      zeroPriceOnly
    }
  });
};


  return (
 <div style={{
  paddingBottom: "60px",
  //paddingTop: "140px",   // 🔥 IMPORTANT (height of fixed filter bar)
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh"
}}>
      <h1>Stock on shelf - Financials</h1>

   
<div style={{
  display: "flex",
  overflowX: "auto",
  gap: "12px",
  alignItems: "stretch",

 position: "sticky",
top: "50px",
zIndex: 10,

  background: "white",
  padding: "10px 10px",
  borderBottom: "2px solid #ccc"
}}>

{/* Detail Level */}
<div style={{
  border: "1px solid #ccc",
  padding: "10px",
  borderRadius: "6px",
  minWidth: "180px",
  flexShrink: 0
}}>
  <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
    Detail level
  </div>

  <div style={{
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    alignItems: "center",
    flexWrap: "wrap"
  }}>
    <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <input
        type="radio"
        checked={viewOption === "Pharmacy"}
        onChange={() => setViewOption("Pharmacy")}
      />
      Pharmacy
    </label>

    <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <input
        type="radio"
        checked={viewOption === "Summary"}
        onChange={() => setViewOption("Summary")}
      />
      Summary
    </label>

    <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <input
        type="radio"
        checked={viewOption === "Detail"}
        onChange={() => setViewOption("Detail")}
      />
      Detail
    </label>
  </div>
</div>
  {/* Filters */}
 {/* Filters */}
<div style={{ border: "1px solid #ccc", padding: "10px", borderRadius: "6px", minWidth: "220px" }}>
  
  <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
    Filters
  </div>

  <div style={{
    display: "flex",
    flexDirection: "column",
    gap: "6px"
  }}>

    {/* ROW 1 */}
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: "10px"
    }}>

      <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "13px" }}>
        <input
          type="checkbox"
          checked={splitPackOnly}
          onChange={(e) => setSplitPackOnly(e.target.checked)}
        />
        Split pack
      </label>

      <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "13px" }}>
        Expires ≤
        <input
          type="number"
          value={expiringWithin}
          onChange={(e) => setExpiringWithin(e.target.value)}
          style={{ width: "55px", height: "24px" }}
        />
        wks
      </label>

      <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "13px" }}>
        On shelf ≥
        <input
          type="number"
          value={onShelfMoreThan}
          onChange={(e) => setOnShelfMoreThan(e.target.value)}
          style={{ width: "55px", height: "24px" }}
        />
        wks
      </label>

      <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "13px" }}>
        £ ≥
        <input
          type="number"
          value={priceThreshold}
          onChange={(e) => setPriceThreshold(e.target.value)}
          style={{ width: "65px", height: "24px" }}
        />
      </label>

    </div>

    {/* ROW 2 */}
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: "10px"
    }}>

      {/* Pharmacy + Location */}
<div style={{ display: "flex", alignItems: "center", gap: "6px" }}>

  <select
    value={selectedPharmacy}
    onChange={(e) => setSelectedPharmacy(e.target.value)}
    style={{ height: "36px" }}
  >
    <option value="">All pharmacies</option>
    {combinedPharmacyNames.map((name, i) => (
      <option key={i} value={name}>{name}</option>
    ))}
  </select>

  <select
    value={selectedLocation}
    onChange={(e) => setSelectedLocation(e.target.value)}
    style={{ height: "36px" }}
  >
    <option value="">All locations</option>
    {uniqueLocations.map((loc, i) => (
      <option key={i} value={loc}>{loc}</option>
    ))}
  </select>

</div>

      <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "13px" }}>
        🔍
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ width: "140px", height: "24px" }}
        />
      </label>

      <label style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        padding: "4px 6px",
        borderRadius: "4px",
        fontSize: "13px",
        backgroundColor: zeroPriceStats.allHavePrice ? "#d4edda" : "#f8d7da"
      }}>
        <input
          type="checkbox"
          checked={zeroPriceOnly}
          onChange={(e) => setZeroPriceOnly(e.target.checked)}
        />
        Zero price
      </label>

      <button
        onClick={resetFilters}
        style={{
          cursor: "pointer",
          border: "1px solid #ccc",
          background: "#f5f5f5",
          padding: "6px 10px",
          borderRadius: "4px",
          fontWeight: "bold",
          color: "black",
          fontSize: "13px"
        }}
      >
        Clear filters
      </button>

    </div>

  </div>

</div>
 {/* Item Status */}
<div style={{
  border: "1px solid #ccc",
  padding: "10px",
  borderRadius: "6px",
  minWidth: "180px"
}}>
  <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
    Item status
  </div>

  <div style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "6px"
  }}>
    <button onClick={() => openStatusPopup("On shelf")}>On shelf</button>
    <button onClick={() => openStatusPopup("Archived")}>Archived</button>
    <button onClick={() => openStatusPopup("Transferred")}>Transferred</button>
    <button onClick={() => openStatusPopup("Destroyed")}>Destroyed</button>
  </div>
</div>
{/* Zero Value Items */}
<div style={{ border: "1px solid #ccc", padding: "10px", borderRadius: "6px", minWidth: "160px" }}>
  <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
    Zero value items
  </div>


  

  <div style={{ marginBottom: "6px" }}>
    {zeroValueItems.length} drugs
  </div>

  <button
    onClick={() => {
      const initial = {};
      zeroValueItems.forEach(i => {
    initial[i.gtin] = "";
      });
      setZeroValueEdits(initial);
     setZeroValueEdits(initial);


     // 🔥 RESET STATS + HIGHLIGHT EVERY TIME POPUP OPENS
setLookupStats({
  total: zeroValueItems.length,
  updated: 0
});
setRecentlyUpdatedGtins([]);

setZeroValuePopup(true);
    }}
  >
    Manage values
  </button>
</div>



{/* ✅ QR BLOCK GOES HERE */}
{selectedPharmacy && (() => {
  const members = JSON.parse(localStorage.getItem("members") || "[]");
  const matched = members.find(m => m.pharmacyName === selectedPharmacy);
  const pharmacyId = matched ? matched.pharmacyId : "";

 const barcodeValue = `SITE:${pharmacyId}\n${selectedPharmacy}\n${localStorage.getItem("userId") || ""}\n${localStorage.getItem("organisationName") || ""}`;
  return (
    <div style={{
      border: "1px solid #ccc",
      padding: "10px",
      borderRadius: "6px",
      minWidth: "180px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "6px"
    }}>
      <div style={{ fontWeight: "bold" }}>
        Site QR code
      </div>

      <QRCodeSVG
        id="siteQrCode"
        value={barcodeValue}
        size={120}
        level="H"
        includeMargin={true}
      />

      <button onClick={() => {
        const printWindow = window.open('', '', 'width=400,height=500');
        const svg = document.getElementById("siteQrCode")?.outerHTML;

        printWindow.document.write(`
          <html>
            <body style="text-align:center;">
              <h3>${selectedPharmacy}</h3>
              ${svg}
            </body>
          </html>
        `);

        printWindow.document.close();
        printWindow.print();
      }}>
        🖨️ Print
      </button>
    </div>
  );
})()}
  {/* Right side actions */}
  <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "10px" }}>

  {/* ✅ REFRESH BUTTON */}
  <button
    disabled={loading}
    style={{
      fontSize: "13px",
      padding: "6px 12px",
      fontWeight: "bold",
      backgroundColor: loading ? "#ddd" : "#28a745",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: loading ? "not-allowed" : "pointer"
    }}
    onClick={!loading ? fetchInventoryData : undefined}
  >
    {loading ? "Refreshing..." : "Refresh"}
  </button>

  {/* ✅ EXPORT BUTTON */}
  <button
    style={{
      fontSize: "13px",
      padding: "6px 12px",
      fontWeight: "bold",
      backgroundColor: "#4A90E2",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer"
    }}
    onClick={handleExport}
  >
    Export All Data
  </button>

</div>

</div>

<div style={{
  display: "flex",
  marginTop: "10px",
  height: "calc(100vh - 200px)",   // 🔥 locks available space
  overflow: "hidden"
}}>
  {/* LEFT: TABLE */}
<div style={{
  flex: 1,
  overflow: "auto",
  height: "100%"
}}>
    <table border="1" cellPadding="8" style={{ width: "100%" }}>
     <thead>
  <tr>
 <th onClick={() => handleSort('pharmacyName')}>
  Pharmacy{getSortIndicator('pharmacyName')}
</th>
<th onClick={() => handleSort('drug')}>
  Drug{getSortIndicator('drug')}
</th>

   
    <th>No. packets</th>
   <th onClick={() => handleSort('totalPrice')}>
  Total value (£){getSortIndicator('totalPrice')}
</th>
   {viewOption === "Detail" && (
  <>
<th>Shelf</th>
    <th>Qty</th>
  
    <th>Serial No.</th>
    <th>Batch No.</th>

    <th onClick={() => handleSort('expiresIn')}>
      Expires in (wks){getSortIndicator('expiresIn')}
    </th>
    <th onClick={() => handleSort('onShelfFor')}>
      On shelf (wks){getSortIndicator('onShelfFor')}
    </th>
  </>
)}

  </tr>
</thead>
<tbody>
  {displayData.map((row, i) => (
  <tr
  key={i}
style={{
  backgroundColor:
    row.expiresIn < -500
      ? "white"
      : row.expiresIn <= 0
      ? "lightcoral"
      : row.grouped
      ? "moccasin"
      : "white",
  cursor: "pointer"
}}

  onClick={() => setPopupData(row.items)}
>

      <td>{row.pharmacyName}</td>

<td>
  {viewOption === "Detail"
    ? row.amppNm || row.vmppNm || ""
    : row.drug || row.amppNm || ""}
</td>







      <td>{row.totalPackets}</td>
    <td onClick={(e) => e.stopPropagation()}>
  {(row.totalPrice / 100).toFixed(2)}

{(viewOption !== "Pharmacy" && row.items && row.items.length === 1) && (
    <span
      style={{ marginLeft: "6px", cursor: "pointer" }}
      title="Edit value"
      onClick={() => {
      const first = row.items && row.items.length > 0 ? row.items[0] : null;
if (!first || !first.gtin) return;

   setEditItem({
  id: first._id,   // 🔥 THIS IS THE KEY FIX
  drugName: first.drugName || first.vmppNm,
  currentValue: first.price ? first.price / 100 : 0
});
        setEditValue(first.price ? (first.price / 100).toFixed(2) : "0.00");
      }}
    >
      ✏️
    </span>
  )}
</td>

   <td style={{ maxWidth: "4cm", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
    title={
      viewOption !== "Detail" && row.items
        ? [...new Set(row.items.map(i => i.location || ""))].join(", ")
        : row.location
    }
>
  {viewOption === "Detail"
    ? row.location
    : row.items
      ? [...new Set(row.items.map(i => i.location || ""))].join(", ")
      : row.location}
</td>
     {viewOption === "Detail" && (
  <>
    
<td>
  {row.qtval}
  {row.splitpack === true && (
    <span title="Split pack" style={{ marginLeft: '4px', color: 'orange' }}>
      💊
    </span>
  )}
</td>


      <td>{row.serialNumber}</td>
      <td>{row.batchNumber}</td>

    {(() => {
      const expiresIn = getWeeksUntil(row.items?.[0]?.expiryDate);
      return <td>{expiresIn > -500 ? expiresIn : "n/a"}</td>;
    })()}
    <td>{getWeeksSince(row.items?.[0]?.firstScanned)}</td>
  </>
)}

    </tr>
  ))}
</tbody>
</table>
  </div>





</div>
      
      <div style={{ position: "fixed", bottom: 0, width: "100%", backgroundColor: "#f1f1f1", padding: "10px", textAlign: "center" }}>
        Total packets: {totalPackets} &nbsp;&nbsp;&nbsp; Total value: £{(totalPrice / 100).toFixed(2)}
      </div>






{logPopupData && (
  <div
    style={{
      position: 'fixed',
      top: '10%',
      left: '10%',
      width: '80%',
      height: '80%',
      backgroundColor: 'white',
      border: '2px solid black',
      borderRadius: '10px',
      padding: '20px',
      overflowY: 'scroll',
      zIndex: 2000,
    }}
  >
    <h3>Log Details</h3>
    <table border="1" cellPadding="6" style={{ width: "100%" }}>
      <thead>
        <tr>
          <th>Date & Time</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {logPopupData
          .slice() // Create a copy to avoid mutating original
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Descending
          .map((logItem, idx) => (
            <tr key={idx}>
              <td>
                {logItem.createdAt
                  ? new Date(logItem.createdAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "n/a"}
              </td>
              <td>{logItem.action || "n/a"}</td>
            </tr>
          ))}
      </tbody>
    </table>
    <div style={{ textAlign: "right", marginTop: "10px" }}>
      <button onClick={() => setLogPopupData(null)}>Close</button>
    </div>
  </div>
)}

{logPopupData && (
  <div
    style={{
      position: 'fixed',
      top: '10%',
      left: '10%',
      width: '80%',
      height: '80%',
      backgroundColor: 'white',
      border: '2px solid black',
      borderRadius: '10px',
      padding: '20px',
      overflowY: 'scroll',
      zIndex: 2000,
    }}
  >
    <h3>Log Details</h3>
    <table border="1" cellPadding="6" style={{ width: "100%" }}>
      <thead>
        <tr>
          <th>Date & Time</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {logPopupData
          .slice() // Create a copy
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Descending
          .map((logItem, idx) => (
            <tr key={idx}>
              <td>
                {logItem.createdAt
                  ? new Date(logItem.createdAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "n/a"}
              </td>
              <td>{logItem.action || "n/a"}</td>
            </tr>
          ))}
      </tbody>
    </table>
    <div style={{ textAlign: "right", marginTop: "10px" }}>
      <button onClick={() => setLogPopupData(null)}>Close</button>
    </div>
  </div>
)}



   
{popupData && (
  <div style={{ position: 'fixed', top: '5%', left: '5%', width: '90%', height: '90%', backgroundColor: 'white', border: '2px solid black', borderRadius: '10px', padding: '20px', overflowY: 'scroll', zIndex: 1000 }}>
    <h2>Item Details</h2>
    <table border="1" cellPadding="6" style={{ width: "100%" }}>
      <thead>
        <tr>
          <th>Pharmacy</th><th>Drug</th><th>Packets</th><th>Qty</th><th>Price (£)</th><th>Location</th><th>Serial</th><th>Batch</th><th>Expiry</th><th>Status</th><th>First Scanned</th>
        </tr>
      </thead>
      <tbody>
        {popupData.map((item, i) => {
          let expiryDateValue = "";
          if (item.expiryDate && !item.expiryDate.includes("1980")) {
            expiryDateValue = new Date(item.expiryDate).toISOString().slice(0, 10);
          }

          const canEditExpiry =
            !item.expiryDate ||
            item.expiryDate === "" ||
            item.expiryDate.includes("1980");

          return (
            <tr
              key={i}
              style={{ cursor: item.log && item.log.length > 0 ? "pointer" : "default" }}
              onClick={() => {
                if (item.log && Array.isArray(item.log) && item.log.length > 0) {
                  setLogPopupData(item.log);
                }
              }}
            >
              <td>{item.pharmacyName}</td>
              <td>{item.drugName || item.amppNm}</td>
              <td>{parseInt(item.balance || 0)}</td>
              <td>
                {(!item.splitpack && item.balance !== 0 && item.qtval !== 0)
                  ? item.qtval * item.balance
                  : item.qtval}
                {item.splitpack === true && (
                  <span title="Split pack" style={{ marginLeft: '4px', color: 'orange' }}>
                    💊
                  </span>
                )}
              </td>
              <td>{(item.price / 100).toFixed(2)}</td>
              <td>{item.location}</td>
              <td>{item.serialNumber}</td>
              <td>{item.batchNumber}</td>
            <td onClick={(e) => e.stopPropagation()}>
                <input
                  type="date"
                  value={expiryDateValue}
                  disabled={!canEditExpiry}
                  onChange={async (e) => {
                    const newDate = e.target.value;
                    const oldDate = item.expiryDate && !item.expiryDate.includes("1980")
                      ? new Date(item.expiryDate).toLocaleDateString("en-GB")
                      : "n/a";
                    try {
                    const token = localStorage.getItem("authToken");

await axios.post('https://api.pharmacegroup.co.uk/updateExpiry', {
  id: item._id,
  expiryDate: newDate,
  logEntry: {
    action: `Expiry date changed from ${oldDate} to ${new Date(newDate).toLocaleDateString("en-GB")}`,
    createdAt: new Date().toISOString(),
  }
}, {
  headers: {
    "Authorization": `Bearer ${token}`
  }
});

                      await fetchInventoryData();
                      const updatedData = [...popupData];
                      updatedData[i] = {
                        ...updatedData[i],
                        expiryDate: newDate,
                        updated: new Date().toISOString(),
                        log: [
                          {
                            action: `Expiry date changed from ${oldDate} to ${new Date(newDate).toLocaleDateString("en-GB")}`,
                            createdAt: new Date().toISOString(),
                          },
                          ...(updatedData[i].log || []),
                        ],
                      };
                      setPopupData(updatedData);
                    } catch (error) {
                      console.error("Error updating expiry date:", error);
                      alert("Failed to update expiry date. Please try again.");
                    }
                  }}
                />
              </td>
              <td onClick={(e) => e.stopPropagation()}>
                <select
                  value={item.status}
                  onChange={async (e) => {
                    const newStatus = e.target.value;
                    const oldStatus = item.status || "n/a";
                    try {
                   await axios.post('https://api.pharmacegroup.co.uk/updateStatus', {
  id: item._id,
  status: newStatus,
  logEntry: {
    action: `Status changed from ${oldStatus} to ${newStatus}`,
    createdAt: new Date().toISOString(),
  }
}, {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`
  }
});

                      await fetchInventoryData();
                      const updatedData = [...popupData];
                      updatedData[i] = {
                        ...updatedData[i],
                        status: newStatus,
                        updated: new Date().toISOString(),
                        log: [
                          {
                            action: `Status changed from ${oldStatus} to ${newStatus}`,
                            createdAt: new Date().toISOString(),
                          },
                          ...(updatedData[i].log || []),
                        ],
                      };
                      setPopupData(updatedData);
                    } catch (error) {
                      console.error("Error updating status:", error);
                      alert("Failed to update status. Please try again.");
                    }
                  }}
                >
                  <option value="On shelf">On shelf</option>
                  <option value="Archived">Archived</option>
                  <option value="Destroyed">Destroyed</option>
                  <option value="Transfer to warehouse">Transfer to warehouse</option>
                </select>
              </td>
              <td>{item.firstScanned ? new Date(item.firstScanned).toLocaleDateString("en-GB") : ""}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <div style={{ textAlign: "right", marginTop: "10px" }}>
      <button onClick={() => setPopupData(null)}>Close</button>
    </div>
  </div>
)}


{statusPopupData && (
  <div
    style={{
      position: 'fixed',
      top: '5%',
      left: '5%',
      width: '90%',
      height: '90%',
      backgroundColor: 'white',
      border: '2px solid black',
      borderRadius: '10px',
      padding: '20px',
      overflow: 'hidden',
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h2>{statusPopupTitle} Drugs</h2>
      <button onClick={() => setStatusPopupData(null)}>Close</button>
    </div>
    <div style={{ marginBottom: "10px", display: "flex", gap: "10px" }}>
      <input
        type="text"
        placeholder="Search..."
        value={popupSearchQuery}
        onChange={(e) => setPopupSearchQuery(e.target.value)}
        style={{ flex: 1, padding: "5px" }}
      />
      <button onClick={handlePopupExport}>Export</button>
    </div>
    <div style={{ flex: 1, overflowY: "auto" }}>
      <table border="1" cellPadding="6" style={{ width: "100%" }}>
        <thead style={{ position: "sticky", top: 0, background: "#f1f1f1" }}>
          <tr>
            <th onClick={() => handleSort('pharmacyName')}>Pharmacy{getSortIndicator('pharmacyName')}</th>
            <th onClick={() => handleSort('drugName')}>Drug{getSortIndicator('drugName')}</th>
            <th onClick={() => handleSort('balance')}>Packets{getSortIndicator('balance')}</th>
            <th onClick={() => handleSort('qtval')}>Qty{getSortIndicator('qtval')}</th>
            <th onClick={() => handleSort('price')}>Price (£){getSortIndicator('price')}</th>
            <th onClick={() => handleSort('location')}>Location{getSortIndicator('location')}</th>
            <th onClick={() => handleSort('serialNumber')}>Serial{getSortIndicator('serialNumber')}</th>
            <th onClick={() => handleSort('batchNumber')}>Batch{getSortIndicator('batchNumber')}</th>
            <th onClick={() => handleSort('expiryDate')}>Expiry{getSortIndicator('expiryDate')}</th>
            <th onClick={() => handleSort('firstScanned')}>First Scanned{getSortIndicator('firstScanned')}</th>
            <th onClick={() => handleSort('status')}>Status{getSortIndicator('status')}</th>
          </tr>
        </thead>
        <tbody>
          {sortedPopupData.map((item, idx) => {
            let expiryDateValue = "";
            if (item.expiryDate && !item.expiryDate.includes("1980")) {
              expiryDateValue = new Date(item.expiryDate).toISOString().slice(0, 10);
            }
            const canEditExpiry =
              !item.expiryDate ||
              item.expiryDate === "" ||
              item.expiryDate.includes("1980");

            return (
              <tr
                key={idx}
                style={{ cursor: item.log && item.log.length > 0 ? "pointer" : "default" }}
                onClick={() => {
                  if (item.log && Array.isArray(item.log) && item.log.length > 0) {
                    setLogPopupData(item.log);
                  }
                }}
              >
                <td>{item.pharmacyName}</td>
                <td>{item.drugName || item.vmppNm}</td>
                <td>{parseInt(item.balance || 0)}</td>
                <td>{item.qtval}</td>
                <td>{item.price ? (item.price / 100).toFixed(2) : ""}</td>
                <td>{item.location}</td>
                <td>{item.serialNumber}</td>
                <td>{item.batchNumber}</td>
                <td onClick={(e) => e.stopPropagation()}>
                  <input
                    type="date"
                    value={expiryDateValue}
                    disabled={!canEditExpiry}
                    onChange={async (e) => {
                      const newDate = e.target.value;
                      const oldDate = item.expiryDate && !item.expiryDate.includes("1980")
                        ? new Date(item.expiryDate).toLocaleDateString("en-GB")
                        : "n/a";
                     try {
  await axios.post('https://api.pharmacegroup.co.uk/updateExpiry', {
    id: item._id,
    expiryDate: newDate,
    logEntry: {
      action: `Expiry date changed from ${oldDate} to ${new Date(newDate).toLocaleDateString("en-GB")}`,
      createdAt: new Date().toISOString(),
    }
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`
    }
  });

                        await fetchInventoryData();
                      } catch (error) {
                        console.error("Error updating expiry date:", error);
                        alert("Failed to update expiry date. Please try again.");
                      }
                    }}
                  />
                </td>
                <td>{item.firstScanned ? new Date(item.firstScanned).toLocaleDateString("en-GB") : ""}</td>
                <td onClick={(e) => e.stopPropagation()}>
                  <select
                    value={item.status}
                    onChange={async (e) => {
                      const newStatus = e.target.value;
                      const oldStatus = item.status || "n/a";
                  try {
  await axios.post('https://api.pharmacegroup.co.uk/updateStatus', {
    id: item._id,
    status: newStatus,
    logEntry: {
      action: `Status changed from ${oldStatus} to ${newStatus}`,
      createdAt: new Date().toISOString(),
    }
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`
    }
  });

                        await fetchInventoryData();
                      } catch (error) {
                        console.error("Error updating status:", error);
                        alert("Failed to update status. Please try again.");
                      }
                    }}
                  >
                    <option value="On shelf">On shelf</option>
                    <option value="Archived">Archived</option>
                    <option value="Destroyed">Destroyed</option>
                    <option value="Transfer to warehouse">Transfer to warehouse</option>
                  </select>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
)}



{zeroValuePopup && (
  <div style={{
    position: "fixed",
    top: "5%",
    left: "10%",
    width: "80%",
    height: "80%",
    backgroundColor: "white",
    border: "2px solid black",
    borderRadius: "10px",
    padding: "20px",
    overflow: "hidden",
    zIndex: 3000,
    display: "flex",
    flexDirection: "column"
  }}>
    <h2>Zero Value Items</h2>

    {/* STATS */}
    <div style={{ marginBottom: "10px", fontSize: "13px" }}>
      <div>Number of entries: <strong>{lookupStats.total}</strong></div>
      <div>Number with value inserted: <strong>{lookupStats.updated}</strong></div>
    </div>

    <div style={{ flex: 1, overflowY: "auto" }}>
      <table border="1" cellPadding="6" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th
              onClick={() => handleZeroSort("drugName")}
              style={{ cursor: "pointer" }}
            >
              Drug{getZeroSortIndicator("drugName")}
            </th>
            <th>SNOMED</th>
            <th>GTIN</th>
            <th
              onClick={() => handleZeroSort("value")}
              style={{ cursor: "pointer" }}
            >
              New Value (£){getZeroSortIndicator("value")}
            </th>
          </tr>
        </thead>

        <tbody>
          {[...zeroValueItems]
            .sort((a, b) => {
              if (!zeroSortConfig.key) return 0;

              let aVal = a[zeroSortConfig.key] || "";
              let bVal = b[zeroSortConfig.key] || "";

              // 🔥 value column uses edits
              if (zeroSortConfig.key === "value") {
                aVal = parseFloat(zeroValueEdits[a.gtin] || 0);
                bVal = parseFloat(zeroValueEdits[b.gtin] || 0);
              }

              // 🔥 string sort for drug
              if (zeroSortConfig.key === "drugName") {
                return zeroSortConfig.direction === "ascending"
                  ? (aVal || "").localeCompare(bVal || "")
                  : (bVal || "").localeCompare(aVal || "");
              }

              // 🔥 numeric sort fallback
              if (aVal < bVal) return zeroSortConfig.direction === "ascending" ? -1 : 1;
              if (aVal > bVal) return zeroSortConfig.direction === "ascending" ? 1 : -1;
              return 0;
            })
            .map((item, i) => (
              <tr
                key={i}
                style={{
                  backgroundColor: recentlyUpdatedGtins.includes(item.gtin)
                    ? "#d4edda"
                    : "white",
                  transition: "background-color 0.5s ease"
                }}
              >
                <td>{item.drugName}</td>
                <td>{item.snomed}</td>
                <td>{item.gtin || ""}</td>
                <td>
                  <input
                    type="number"
                    value={zeroValueEdits[item.gtin] || ""}
                    onChange={(e) => {
                      setZeroValueEdits(prev => ({
                        ...prev,
                        [item.gtin]: e.target.value
                      }));
                    }}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>

    {/* BUTTON ROW */}
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "10px",
      gap: "10px"
    }}>

      <button onClick={() => setZeroValuePopup(null)}>Cancel</button>

      {/* LOOKUP BUTTON */}
      <button
        onClick={handleLookupPrices}
        disabled={lookupLoading}
        style={{
          background: "#6c757d",
          color: "white",
          border: "none",
          padding: "6px 10px",
          borderRadius: "4px",
          cursor: lookupLoading ? "not-allowed" : "pointer"
        }}
      >
        {lookupLoading ? "Looking up..." : "Lookup prices"}
      </button>

      {/* APPLY BUTTON */}
      <button
        onClick={async () => {
          if (!window.confirm("Apply changes?")) return;

          try {
            const token = localStorage.getItem("authToken");

            for (const item of zeroValueItems) {
              const value = zeroValueEdits[item.gtin];

              if (value === "" || isNaN(value)) continue;

              await fetch("https://api.pharmacegroup.co.uk/updatePriceBulk", {
                method: "POST",
                headers: {
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  pharmacyId: item.pharmacyId,
                  gtin: item.gtin,
                  newValue: parseFloat(value),
                  onlyIfZero: true
                })
              });
            }

            await fetchInventoryData();
            setZeroValuePopup(null);

          } catch (err) {
            console.error(err);
            alert("Update failed");
          }
        }}
      >
        Apply changes
      </button>

    </div>
  </div>
)}
{editItem && (
  <div style={{
    position: "fixed",
    top: "30%",
    left: "30%",
    width: "40%",
    backgroundColor: "white",
    border: "2px solid black",
    borderRadius: "10px",
    padding: "20px",
    zIndex: 4000
  }}>
    <h3>Edit Item Value</h3>

    <div><strong>Drug:</strong> {editItem.drugName}</div>
    <div><strong>GTIN:</strong> {editItem.gtin}</div>

    <div style={{ marginTop: "10px" }}>
      <strong>Value (£):</strong>
      <input
        type="number"
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        style={{ marginLeft: "10px" }}
      />
    </div>

    <div style={{ marginTop: "15px", display: "flex", justifyContent: "space-between" }}>
      <button onClick={() => setEditItem(null)}>Cancel</button>

      <button
        onClick={async () => {
          if (!window.confirm("Apply new value?")) return;

 try {
  const token = localStorage.getItem("authToken");

  await fetch("https://api.pharmacegroup.co.uk/updatePrice", {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id: editItem.id,   // 🔥 IMPORTANT: must be _id
      newValue: parseFloat(editValue),
      logEntry: {
        action: `Price changed to £${parseFloat(editValue).toFixed(2)}`,
        createdAt: new Date().toISOString()
      }
    })
  });

  await fetchInventoryData();
  setEditItem(null);

} catch (err) {
  console.error(err);
  alert("Update failed");
}       }}
      >
        Apply
      </button>
    </div>
  </div>
)}

</div>
  );




  

};




export default StockFinancials;
